import * as React from "react";
import { connect } from "react-redux";
import styled from "styled-components";

import { tournamentCurrency } from "../Icons/Kuchka";
import { getActiveDeals } from "../../redux/reducer/deals";
import Gettext from "../common/Gettext";
import Money from "../Money";
import { rtl } from "../common/styled-mixins";

const Container = styled.div`
  direction: ${({ theme }) => theme.direction};
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  padding-right: 42px;
`;

const Item = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 0 10px;

  :first-of-type {
    ${({ theme }) =>
      rtl("border-right", `1px solid ${theme.ticksBorderColor}`)};
  }
`;

const Value = styled.div`
  font-size: 20px;
  line-height: 1.2;
  color: ${({ theme }) => theme.foreground};
`;

const Profit = styled(Value)`
  color: ${({ isPositive, theme }) => (isPositive ? theme.upper : theme.lower)};
`;

const Text = styled.div`
  font-size: 12px;
  color: #99959d;
  white-space: nowrap;
`;

class DealsStats extends React.Component {
  render() {
    if (!this.props.deals.length) return null;
    if (!this.props.lastPoints.length) return null;

    let investment = 0;
    let profit = 0;

    let pointsByStock = this.props.lastPoints.reduce((res, point) => {
      res[point.stock] = point;
      return res;
    }, {});

    this.props.deals.forEach(deal => {
      let isProfitable;
      const point = pointsByStock[deal.stock];
      if (point && point.value !== deal.value) {
        if (point.value !== deal.value) {
          isProfitable = deal.bidType
            ? point.value > deal.value
            : point.value < deal.value;
        }
      }

      investment += deal.amount;

      if (isProfitable !== undefined) {
        profit += isProfitable
          ? (deal.percent * deal.amount) / 100
          : -1 * deal.amount;
      }
    });

    const currency =
      this.props.mode === "tournament" ? tournamentCurrency : null;
    return (
      <Container>
        <Item>
          <Value>
            <Money currency={currency}>{investment}</Money>
          </Value>
          <Text>
            <Gettext>Total investment</Gettext>
          </Text>
        </Item>

        <Item>
          <Profit isPositive={profit >= 0}>
            <Money currency={currency}>{profit}</Money>
          </Profit>
          <Text>
            <Gettext>Current profit</Gettext>
          </Text>
        </Item>
      </Container>
    );
  }
}

export default connect((state, props) => {
  let lastPoints = [];
  let deals = [];

  state.tabs.tabs.forEach(tab => {
    const points = state.points[tab];
    const lastPoint =
      points && points.length > 0 ? points[points.length - 1] : null;
    if (lastPoint) {
      lastPoints = lastPoints.concat([lastPoint]);
    }

    deals = deals.concat(getActiveDeals(tab, state.time, props.deals));
  });

  return {
    deals,
    lastPoints
  };
})(DealsStats);



// WEBPACK FOOTER //
// ./src/components/Toolbar/DealsStats.js